export function has_time(input: string): boolean {
  const timeRegex = /([01]?[0-9]|2[0-3]):[0-5][0-9]/;
  return timeRegex.test(input);
}
export function has_email(input: string): boolean {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(input);
}
export function has_phone(input: string): boolean {
  const phoneRegex = /^(\+\d{1,3}\s?)?(\(\d{1,4}\))?\d{3}(?:[\s.-]?\d{2}){2}\d{2}$/;
  if (phoneRegex.test(input)) {
    return true;
  }
  const suffix = /^\(\+\d\d\)\s\d+/;
  return suffix.test(input);
}
export function has_address(input: string): boolean {
  return input.includes("C/");
}

export function has_country(input: string): boolean {
  const countryRegex = /\b[A-Z][a-z]*\b/;
  return countryRegex.test(input);
}
